/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';

import router from '@/router/index';

// import {comparePosition, extractErrorDetails} from '@/helpers/util.js';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  project_user_invites: [],
  new_invitation: {
    email: '',
    prole: {
      id: 0,
      name: ''
    },
    add_to_company: false
  },
  invite_selected_wps: {},
  error: '',
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getInviteSelectedWPs: (state) => {
    return state.invite_selected_wps;
  },
  getNewInvite: (state) => {
    return state.new_invitation;
  },
  //other stores
  isSelectedWP: (state, getters, rootState, rootGetters) => (id) => {
    const wp = rootGetters['TWorkPackage/getTWorkPackage'](id);
    const key = wp.token + wp.icon + wp.color;
    if (state.invite_selected_wps[key]) {
      for (var i = 0; i < state.invite_selected_wps[key].length; i++) {
        if (state.invite_selected_wps[key][i].id === id) {
          return true;
        }
      }
    }
    return false;
  },
  getProjectUserInvites: (state) => state.project_user_invites,
};
// Actions
const actions = {
  // with Local mutation mutating ultra store
  sendProjectInvitation({commit, rootState}, payload){
    axios({
      url: 'projects/' + payload.project_id + '/invites',
      method: 'POST',
      data: payload.invitation
    })
    .then(resp => {
      commit('reset_new_invitation');
      commit('add_project_invitation', {rootState, payload: {
        project_id: payload.project_id,
        invitation: resp.data.data
      }});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  deleteProjectInvite({commit, rootState}, invitation) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'projects/' + invitation.project.id + '/invites/' + invitation.id,
        method: 'DELETE'
      })
      .then(() => {
        commit('delete_project_invitation', {rootState, invitation});
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  //Local Invitation variables
  loadMembersWPs({commit, rootState}, payload) {
    return new Promise((resolve) => {
      let workpackages = rootState.Ultra.projects[payload.project_id].users.find(user => user.id === payload.user_id).work_packages;
      commit('load_members_wps', workpackages);
      resolve();
    });
  },
  resetNewInvite({commit}){
    commit('reset_new_invitation');
  },
  addInviteSelectedWP({commit, getters}, payload){
    if (payload.edit_member) {
      if (!getters.isSelectedWP(payload.wp.id)) {
        axios({
          url: 'users/' + payload.user_id + '/addtworkpackages',
          method: 'PUT',
          data: {
            work_packages: [payload.wp.id]
          }
        })
        .then(() => {
          commit('add_invite_selected_wp', payload.wp);
        });
      } else {
        axios({
          url: 'users/' + payload.user_id + '/removetworkpackages',
          method: 'PUT',
          data: {
            work_packages: [payload.wp.id]
          }
        })
        .then(() => {
          commit('add_invite_selected_wp', payload.wp);
        });
      }
    } else {
      commit('add_invite_selected_wp', payload.wp);
    }
  },
  addInviteSelectedWPs({commit, getters, rootGetters}, payload){
    const filter = {
      color: payload.wp.color,
      token: payload.wp.token,
      icon: payload.wp.icon
    };
    let wps = rootGetters['Train/getTWorkPackagesFiltered']({
      project_id: payload.project_id,
      trains: [payload.train_id],
      filter: filter,
    });
    if (payload.edit_member) {
    let workpackages = [];
    wps.forEach(wp => {
      workpackages.push(wp.id);
    });
    if (!getters.isSelectedWP(payload.wp.id)) {
      axios({
        url: 'users/' + payload.user_id + '/addtworkpackages',
        method: 'PUT',
        data: {
          work_packages: workpackages
        }
      })
      .then(() => {
        // for (let i = 0; i < wps.length; i++) {
        //   commit('add_invite_selected_wp', wps[i]);
        // }
          commit('add_invite_selected_wps', {wps: wps, add: true});
      });
    } else {
      axios({
        url: 'users/' + payload.user_id + '/removetworkpackages',
        method: 'PUT',
        data: {
          work_packages: workpackages
        }
      })
      .then(() => {
        // for (let i = 0; i < wps.length; i++) {
        //   commit('add_invite_selected_wp', wps[i]);
        // }
        commit('add_invite_selected_wps', {wps: wps, add: false});
      });
    }
  } else {
    let add = !getters.isSelectedWP(payload.wp.id);
    // for (let i = 0; i < wps.length; i++) {
    //   commit('add_invite_selected_wp', wps[i]);
    // }
    commit('add_invite_selected_wps', {wps: wps, add: add});
  }
  },
  removeInviteSelectedWPs({commit}, payload) {
    if (payload.edit_member) {
      let workpackages = [];
      state.invite_selected_wps[payload.wp_key].forEach(wp => {
        workpackages.push(wp.id);
      });
      axios({
        url: 'users/' + payload.user_id + '/removetworkpackages',
        method: 'PUT',
        data: {
          work_packages: workpackages
        }
      })
      .then(() => {
        commit('remove_invite_selected_wps', payload.wp_key);
      });
    } else {
      commit('remove_invite_selected_wps', payload.wp_key);
    }
  },
  setNewInviteEmail({commit}, val){
    commit('update_new_invite', { key: 'email', val: val});
  },
  setNewInvitePRole({commit}, val){
    commit('update_new_invite', { key: 'prole', val: val});
  },
  setAddToCompany({commit, rootState}){
    if(rootState.Auth.current_user.business) {
      commit('update_new_invite', { key: 'add_to_company', val: !state.new_invitation.add_to_company});
    }
  },
  requestUserInvitesForManagement({commit}) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'projects/1/invites?all=true&show=showForUserInvites',
        method: 'GET',
        headers: {'Cache-Control': 'no-cache'}
      })
      .then(resp => {
        commit('project_user_invites_for_management', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  taktingUpdateUserInvite({commit}, payload) {
    axios({
      url: 'projects/' + payload.project_id + '/invites/' + payload.id,
      method: 'PUT',
      data: {
        'status': payload.status
      }
    })
    .then(resp => {
      if (resp.status === 204) {
        commit('update_project_user_invites_for_management', payload.id);
      }
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  //User store
  acceptProjectInvite({commit, dispatch}, invitation){
    axios({
      url: 'projects/' + invitation.project.id + '/invites/' + invitation.id,
      method: 'DELETE'
    })
    .then( () => {
      dispatch('Auth/joinProject', invitation.project.id, {root: true});
      dispatch('Ultra/requestUObject', {
        url: [
          {projects: invitation.project.id},
          {'showForInvitaion':''}
        ],
        no_cache: true
      }, {root: true}).then( () => {
        commit('User/remove_invitation', invitation, { root: true });
        router.push({
          name: 'Project',
          params: {
            project_id: invitation.project.id,
          }
        });
      });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  declineProjectInvite({commit}, invitation){
    axios({
      url: 'projects/' + invitation.project.id + '/invites/' + invitation.id,
      method: 'PUT',
      data: {
        status: 'user_rejected'
      }
    })
    .then( () => {
      commit('User/remove_invitation', invitation, { root: true });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
};
// Mutations
const mutations = {
  //local state mutation
  load_members_wps(state, workpackages) {
    state.invite_selected_wps = {};
    workpackages.forEach(wp => {
      let wp_array = [];
      wp.ids.forEach(id => {
        wp_array.push({
          id: id,
          token: wp.token,
          icon: wp.icon,
          color: wp.color,
        });
      });
      Vue.set(state.invite_selected_wps, `${wp.token}${wp.icon}${wp.color}`, wp_array);
    });
  },
  update_new_invite(state, payload){
    state.new_invitation[payload.key] = payload.val;
  },
  add_invite_selected_wp(state, wp){
    const key = wp.token + wp.icon + wp.color;
    if (state.invite_selected_wps[key]) {
      const index = state.invite_selected_wps[key].findIndex(function(item) {
        return item.id == wp.id;
      });
      if (index === -1) {
        state.invite_selected_wps[key].push(wp);
      } else {
        state.invite_selected_wps[key].splice(index, 1);
        if (state.invite_selected_wps[key].length === 0) {
          Vue.delete(state.invite_selected_wps, key);
        }
      }
    } else {
      let wps = [];
      wps.push(wp);
      Vue.set(state.invite_selected_wps, key, wps);
    }
  },
  add_invite_selected_wps(state, payload) {
    const key = payload.wps[0].token + payload.wps[0].icon + payload.wps[0].color;
    if (payload.add && state.invite_selected_wps[key]) {
        payload.wps.forEach(wp => {
          if (state.invite_selected_wps[key].findIndex(item => item.id === wp.id) === -1) {
            state.invite_selected_wps[key].push(wp);
          }
        });
    } else if (payload.add) {
      let wps = JSON.parse(JSON.stringify(payload.wps));
      Vue.set(state.invite_selected_wps, key, wps);
    } else {
      Vue.delete(state.invite_selected_wps, key);
    }
  },
  reset_new_invitation(state){
    state.new_invitation = {
      email: '',
      prole: {
        id: 0,
        name: ''
      },
      add_to_company: false
    };
    state.invite_selected_wps = {};
  },
  remove_invite_selected_wps(state, key){
    Vue.delete(state.invite_selected_wps, key);
  },
  update_project_user_invites_for_management(state, id) {
    state.project_user_invites = [
      ...state.project_user_invites.filter(project_user_invite => project_user_invite.id !== id),
    ];
  },
  project_user_invites_for_management(state, user_invites) {
    state.project_user_invites = user_invites;
  },
  //ultraStore state mutation
  add_project_invitation(state, {rootState, payload}){
    rootState.Ultra.projects[payload.project_id].invitations.push(payload.invitation);
  },
  delete_project_invitation(state, {rootState, invitation}) {
    let invitations = rootState.Ultra.projects[invitation.project.id].invitations;
    let index = invitations.findIndex(item => item.id === invitation.id);
    invitations.splice(index, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
